// extracted by mini-css-extract-plugin
module.exports = {"root":"htPAQCX","rootOpen":"_2o6l1EO","link":"_1xnOcQi"};